import * as moment from 'moment';
import MomentFormatter from './moment.formatter';
import LocationFormatter from './location.formatter';
import HydrologicalNumberFormatter from './hydrological-number.formatter';
import HydrologicalDischargeNumberFormatter from './hydrological-discharge-number.formatter';
import S3UploadService from './s3-upload.service';
import {UnixTimestampFormatter} from './moment.formatter';
import ChartColorService from './chart-color.service';
import configInterceptor from './debug.interceptor';
import imomoVisibleFactory from './imomo-visible.directive';
import IcePhenomenaFormatter from "./ice-phenomena.formatter";
import userPermissionsFactory from './user-permissions.directive';
import NumberRangeFormatter from "./number-range.formatter";
import OrdinalNumberFormatter from "./ordinal-number.formatter";

export default angular.module('imomo.utils', [])
    .config(configInterceptor)
    .directive('imomoVisible', imomoVisibleFactory)
    .directive('userPermissions', userPermissionsFactory)
    .filter('momentFormatter', MomentFormatter)
    .filter('unixTimestampFormatter', UnixTimestampFormatter)
    .filter('locationFormatter', LocationFormatter)
    .filter('hydroDischargeNumberFormatter', HydrologicalDischargeNumberFormatter)
    .filter('hydroNumberFormatter', HydrologicalNumberFormatter)
    .filter('icePhenomenaFormatter', IcePhenomenaFormatter)
    .filter('numberRangeFormatter', NumberRangeFormatter)
    .filter('ordinalNumberFormatter', OrdinalNumberFormatter)
    .service('s3UploadService', S3UploadService)
    .service('chartColorService', ChartColorService)
    .name;


// Modification to the moment library to facilitate JSON transmission.
moment.fn.toJSON = function () {
  return this.format();
};



/** WEBPACK FOOTER **
 ** ./app/utils/utils.module.ts
 **/